module.exports = __webpack_public_path__ + "img/ic_jcb.e48eb8f.svg";